// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"95d63e2c","553":"6b4bdc21","977":"26b16304"}[chunkId] + ".chunk.js";
};